/**
 * Small behaviours for the product page content sections.
 *  - [data-pd-acc]            <details> that is an accordion on mobile and always open from 750px
 *  - <review-filter>          filters curated review blocks by [data-filter] chips
 *  - <product-recommendations> loads Shopify complementary recommendations through the Section Rendering API
 */
(() => {
  if (window.RMProductSections) return;
  window.RMProductSections = true;

  const desktop = window.matchMedia('(min-width: 750px)');

  const syncAccordions = () => {
    for (const details of document.querySelectorAll('details[data-pd-acc]')) {
      if (desktop.matches) {
        details.open = true;
      } else if (!details.dataset.synced) {
        details.open = details.dataset.mobileOpen === 'true';
      }
      details.dataset.synced = desktop.matches ? '' : 'true';
    }
  };
  syncAccordions();
  desktop.addEventListener('change', syncAccordions);

  class ReviewFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const chip = event.target instanceof Element ? event.target.closest('[data-filter]') : null;
        if (!chip) return;
        for (const other of this.querySelectorAll('[data-filter]')) {
          other.setAttribute('aria-pressed', String(other === chip));
        }
        this.#apply(chip.dataset.filter);
      });
    }

    #apply(filter) {
      let visible = 0;
      for (const review of this.querySelectorAll('[data-review]')) {
        let show = true;
        if (filter === 'photos') show = review.dataset.photo === 'true';
        else if (filter.startsWith('tag:')) show = review.dataset.tag === filter.slice(4);
        review.hidden = !show;
        if (show) visible += 1;
      }
      const empty = this.querySelector('[data-review-empty]');
      if (empty) empty.hidden = visible > 0;
    }
  }
  if (!customElements.get('review-filter')) customElements.define('review-filter', ReviewFilter);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        this.#load();
      }, { rootMargin: '400px' });
      observer.observe(this);
    }

    async #load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = await response.text();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
        if (next && next.innerHTML.trim()) {
          this.innerHTML = next.innerHTML;
          this.dataset.loaded = 'true';
        }
      } catch (error) {
        /* recommendations are optional */
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
